// extracted by mini-css-extract-plugin
export var labelWrapper = "_hu-0";